import { tss } from 'tss-react';
import { useTheme, alpha } from '@mui/material/styles';

export default tss.create(({ color: colorProp, backgroundColor: backgroundColorProp }) => {
  const theme = useTheme();

  const color = colorProp || theme.palette.text.primary;
  const backgroundColor =
    backgroundColorProp || (theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[700]);

  return {
    root: {
      color,
      backgroundColor,
      '&:hover': {
        backgroundColor: alpha(backgroundColor, 0.8)
      },
      '& .MuiChip-icon': {
        color,
        padding: 3,
        paddingTop: 2,
        backgroundColor: alpha(theme.palette.common.black, 0.15),
        borderRadius: 9
      }
    }
  };
});
